import { SITE_CONFIG } from '../config';
import { getBlogModifiedDateIso, isBlogPublished } from './blogPublishDate';
import { SEO_CONFIG } from '../config/seo';
import { PUBLIC_ROUTES } from '../publicRoutes';

const origin = (/^https?:\/\//i.test(SEO_CONFIG.DOMAIN) ? SEO_CONFIG.DOMAIN : `https://${SEO_CONFIG.DOMAIN}`).replace(/\/+$/, '');
const escapeXml = (value) => String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&apos;');
const createSlug = (title) => title.toLowerCase().replace(/[^a-z0-9 -]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');

const urlEntry = ({ loc, lastmod, changefreq, priority }) => `
  <url>
    <loc>${escapeXml(loc)}</loc>
    <lastmod>${lastmod}</lastmod>
    <changefreq>${changefreq}</changefreq>
    <priority>${priority}</priority>
  </url>`;

export const updateSitemap = async () => {
  try {
    const blogsResponse = await fetch(`https://tophamtechbe.com/api/treas/blogs/v1/get-blog?site_id=${SITE_CONFIG.SITE_ID}`, {
      headers: { 'X-API-Key': 'treas-api-key-2025' }
    });
    const blogs = blogsResponse.ok ? await blogsResponse.json() : [];
    const today = new Date().toISOString();

    const routeEntries = PUBLIC_ROUTES.map((route) => urlEntry({
      loc: route.url === '/' ? origin : `${origin}${route.url}`,
      lastmod: today,
      changefreq: route.changefreq,
      priority: route.priority
    })).join('');

    const blogEntries = (Array.isArray(blogs) ? blogs : []).filter((blog) => blog.title && isBlogPublished(blog)).map((blog) => urlEntry({
      loc: `${origin}/blog/${createSlug(blog.title)}`,
      lastmod: getBlogModifiedDateIso(blog) || today,
      changefreq: 'monthly',
      priority: 0.6
    })).join('');

    const sitemap = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">${routeEntries}${blogEntries}
</urlset>`;

    const formData = new FormData();
    formData.append('xml', new Blob([sitemap], { type: 'text/xml' }), 'sitemap.xml');
    formData.append('site_id', SITE_CONFIG.SITE_ID);

    const response = await fetch('https://tophamtechbe.com/api/treas/ads/v1/set-xml', {
      method: 'POST',
      headers: { 'X-API-Key': 'treas-api-key-2025' },
      body: formData
    });
    if (!response.ok) throw new Error(`Sitemap update failed with HTTP ${response.status}`);
  } catch (error) {
    console.error('Error updating sitemap:', error);
  }
};
